export const arrowDownSearchSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9998 5.25L11.9998 18.75M11.9998 18.75L18 12.6476M11.9998 18.75L6 12.6474" class="stroke" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
